import React from 'react';
import { useTranslation } from 'react-i18next';
import './OrderGuide.css';

/**
 * „Proces zamówienia” panel of the first mockup (`proc`) for steps 1–3: the
 * title with „Zmień status ręcznie” on the right, and the step card next to
 * „Sposób realizacji”. The eight-step rail above it is the card's shared rail.
 */
export default function OrderGuidePanel({ manualStatus, guide, aside }: {
  /** „Zmień status ręcznie” (absent for roles that cannot change the status). */
  manualStatus?: React.ReactNode;
  guide: React.ReactNode;
  /** „Sposób realizacji” — shown from step 3 (Potwierdzone); steps 1–2 have the full width for the step card. */
  aside?: React.ReactNode;
}) {
  const { t } = useTranslation(['orders']);
  return (
    <section className="zk-section zk-guide" aria-label={t('orders:process.guide.panelTitle')} data-testid="zk-guide">
      <div className="zk-guide__head">
        <span className="zk-guide__panel-title">{t('orders:process.guide.panelTitle')}</span>
        {manualStatus}
      </div>
      <div className={`zk-guide__body${aside ? '' : ' zk-guide__body--single'}`}>
        {guide}
        {aside}
      </div>
    </section>
  );
}

/** The margin card across the whole width (mockup `below`). */
export function OrderGuideBelow({ children }: { children: React.ReactNode }) {
  return <div className="zk-guide-below" data-testid="zk-guide-below">{children}</div>;
}
